import { render, staticRenderFns } from "./YearVueSelect.vue?vue&type=template&id=451b2410&scoped=true&"
import script from "./YearVueSelect.vue?vue&type=script&lang=js&"
export * from "./YearVueSelect.vue?vue&type=script&lang=js&"
import style0 from "./YearVueSelect.vue?vue&type=style&index=0&id=451b2410&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451b2410",
  null
  
)

export default component.exports